<template>
  <div class="tw-container tw-pb-48 tw-px-8 xl:tw-px-24 tw-mx-auto">
    <div class="tw-mb-16">
      <RouterLink to="/menu" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">Menu</RouterLink> >
      <span class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2">Your Bag</span>
    </div>

    <template v-if="userStore.userLocation && userStore.userLocation.id">
      <LocationAlerts
        class="tw-mb-12"
       :location="(userStore.userLocation! as any) as Location" />
    </template>

    <h2 class="tw-text-6xl tw-font-bold tw-mb-12 lg:tw-mb-16">Your Bag</h2>
    <div class="lg:tw-flex">
      <div class="tw-w-full lg:tw-ml-24 xl:tw-ml-48 lg:tw-mr-12 xl:tw-mr-24">

        <EditOrderAlert
          v-if="showEditingOrderAlert"
          :cutoffTime="editCutoffTime"
          @cancelEditOrder="cancelEditOrder"
        />

        <div class="tw-border-b tw-border-gray-700 tw-pb-16" >
          <template v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <BagProduct
              class="tw-w-full tw-mb-8 tw-bg-white tw-shadow-lg tw-rounded-3xl"
              v-for="product in basketStore.basket.products"
              @emitRemoveProduct="removeProduct"
              @emitUpdateProduct="updateProduct"
              :key="'bp-'+product.id.toString()"
              :size="'full'"
              :product="product" />

            <div class="tw-mt-12 tw-font-bold tw-bg-white tw-shadow-lg tw-rounded-3xl tw-py-8 tw-px-8">
              Serving utensils, cutlery, cups and plates will be provided free of charge with your order.
            </div>
          </template>

          <div v-else>
            <h4 class="tw-text-3xl tw-text-center tw-font-bold ">
              Your bag is empty!
            </h4>
          </div>
        </div>

        <div class="tw-mt-16 tw-mb-24" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
          <div class="tw-flex tw-flex-wrap tw--mx-1 lg:tw--mx-4">
            <template v-if="state.recommendationsLoaded">
              <RecommendationProduct
                class="tw-flex tw-flex-1 tw-px-8 tw-flex-grow-1 tw-my-1 tw-px-1 tw-w-full md:tw-w-1/2 lg:tw-mb-8 lg:tw-px-4 xl:tw-w-1/4"
                v-for="product in state.recommendations"
                :key="(product as Product).id"
                :isLoading="isLoadingProduct((product as Product).id)"
                :product="product"
                :size="'small'"
                @handleProductAdd="addProduct"
              />
            </template>

            <template v-else>
              <div 
                class="tw-my-1 tw-px-1 tw-w-full md:tw-w-1/2 lg:tw-w-1/3 xl:tw-mb-8 xl:tw-px-4 xl:tw-w-1/4" 
                v-for="idx in 4" 
                :key="'loader-'+idx">
                <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                  <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                    <SkeletonLoader class="tw-w-full tw-h-48" />
                  </div>
                  <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                    <SkeletonLoader class="tw-w-full tw-h-12" />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

      </div>

      <div class="tw-flex-shrink-0 tw-w-full lg:tw-w-156">
        <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-16">
          <OrderDetails />
          <div class="tw-border-t tw-border-black tw-py-8 tw-px-8" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <div class="tw-mb-10 ">
              <label for="promo_code" class="tw-uppercase tw-pointer-events-none tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Promo Code</label>
              <div class="">
                <input 
                  v-model="state.promoCode"
                  type="text" 
                  @keyup.enter="promocodeKeyup"
                  name="promo_code" 
                  placeholder="Enter promo code"
                  class="tw-block tw-w-full tw-text-2xl tw-py-4 tw-border tw-border-black tw-appearance-none focus:tw-outline-0 tw-bg-transparent focus:tw-ring-0 focus:tw-border-orange-medium focus:tw-ring-orange-medium tw-pl-4 tw-pr-32 tw-rounded-full tw-mb-4" /> 

                  <TwButton 
                    cssClass="tw-block tw-w-full tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-rounded-full tw-text-white tw-uppercase tw-font-bold tw-px-8 tw-py-4 tw-transition-all tw-duration-200 tw-uppercase" 
                    @emit-click="promoAction" 
                    :isLoading="state.submittingPromo"
                    :isDisabled="false" 
                    buttonText="apply code"/>
              </div>
            </div>
          </div>
          <div class="tw-border-t tw-border-black tw-py-8 tw-px-8" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <div class="tw-mb-10" v-if="userStore.user">
              <label for="rewards" class="tw-uppercase tw-pointer-events-none tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Piada Rewards</label>
              <TwButton 
                cssClass="tw-block tw-w-full tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-rounded-full tw-text-white tw-uppercase tw-font-bold tw-px-8 tw-py-4 tw-transition-all tw-duration-200 tw-uppercase"
                @emit-click="rewardsButtonClick" 
                :isLoading="state.applyingRewards"
                :isDisabled="state.rewardsLoading" 
                :buttonText="rewardsButtonText"/>
            </div>
          </div>

          <div class="tw-border-t tw-border-black tw-pt-8 tw-px-8" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <BagTotals 
              @emit-removeDiscount="removeDiscount" />
          </div>
          <div class="tw-text-center tw-mt-16" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <TwButton
              @click="navigateToCheckout"
              class="tw-block tw-w-full tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200" 
              :isDisabled="state.submittingPromo || state.applyingRewards || state.loadingCheckout || state.productsLoading.length > 0"
              :isLoading="state.loadingCheckout"
              :buttonText="checkoutText" />
          </div>
        </div>

        <TwCateringHelp />

      </div>
    </div>

    <TwModal
      v-show="state.showRewardsModal == true"
      :hasAccept="true"
      :hasHeader="false"
      :modalSize="'large'"
    >
      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-font-black tw-text-5xl tw-mb-10">Available Rewards</h2>
          
          <button
            type="button"
            class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
            @click="closeRewardsModal"
          >
            &times;
          </button>
        </div>

        <div class="tw-flex md:tw-flex-wrap tw-flex-column tw-items-center tw-justify-center md:tw-flex-row tw-gap-8 tw-mb-12" v-if="state.rewards != null && state.rewards.length > 0">
          <ReviewCard 
            :class="['md:tw-flex-1 md:tw-basis-1/3 md:tw-max-w-15/32']"
            :reward="reward" 
            :selected="basketStore.basket?.hasRewardApplied(reward.credential_identifier)"
            :isLoading="!state.showRewardsDiscountModal && state.applyingRewards"
            @applyReward="applyRewardClicked"
            @removeReward="removeReward"
            v-index="reward.credential_identifier" 
            v-for="reward in state.rewards"/>
        </div>
        
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            @emit-click="closeRewardsModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Close'"/>
        
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="state.showRewardsDiscountModal == true || state.showPromoDiscountModal == true"
      :hasAccept="true"
      :hasHeader="false"
    >
      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-font-black tw-text-5xl tw-mb-8">{{applyRewardsWarningPromptTitle}}</h2>
          <p class="tw-mb-16 tw-text-3xl">{{applyRewardsWarningPromptText}}</p>
       
          <button
            type="button"
            class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
            @click="closeRewardsDiscountModal"
          >
            &times;
          </button>
        </div>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-bg-transparent tw-border-2 tw-border-orange-medium tw-text-orange-medium hover:tw-text-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            @emit-click="closeRewardsDiscountModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Cancel'"/>

            <template v-if="state.selectedReward && state.showRewardsDiscountModal">
              <TwButton 
              cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
              @emit-click="applyReward(state.selectedReward)" 
              :isLoading="state.applyingRewards"
              :isDisabled="false" 
              :buttonText="'Yes'"/>
            </template>

            <template v-if="state.showPromoDiscountModal">
              <TwButton 
                cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
                @emit-click="submitPromo()" 
                :isLoading="state.submittingPromo"
                :isDisabled="false" 
                :buttonText="'Yes'"/>
            </template>
        
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="state.localPreAdjustmentTime"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeTimeAdjustment"
    >
      <template v-slot:body>
        <p class="tw-mb-16 tw-text-center tw-text-3xl">Your order could not be ready by the requested time.<br/>It has been updated to the next available time slot. </p>
       
        <div class="tw-text-center tw-px-4 tw-font-black tw-text-6xl" v-if="currentBasketTimeWanted">
          {{currentBasketTimeWanted.toFormat('M/dd h:mm a')}}
        </div>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="pickTimeAdjustment" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Pick Another'"/>
          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            @emit-click="closeTimeAdjustment" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Confirm Time'"/>
        
        </div>
      </template>
    </TwModal>  
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, getCurrentInstance,
    onBeforeMount
  } from 'vue';
  import { useRouter } from 'vue-router'

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useCateringOrderStore } from '../../stores/catering_order';
  import { useMenuStore } from '../../stores/menu';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from '../../stores/flashMessages';

  import type BillingAccount from '../../classes/BillingAccount';
  import type BasketBillingMethod from '../../classes/BasketBillingMethod';
  import type CreditCard from '../../classes/CreditCard';
  import type Reward from '../../types/Reward';
  import type FlashMessage from '../../types/FlashMessage';
  import type Product from '../../classes/Product';
  import type BasketProduct from '../../classes/BasketProduct';
  import type Location from '../../classes/Location';
  import type RewardInterface from '../../types/Reward';
  import type Discount from '@/types/Discount';
  import type RewardsProgram from '../../classes/RewardsProgram';
  import { DateTime } from "luxon";
  import Order from '../../classes/Order';

  // Components
  import RecommendationProduct from './_RecommendationProduct.vue';
  import SkeletonLoader from '../../components/SkeletonLoader.vue';
  import EditOrderAlert from '../../components/EditOrderAlert.vue';
  import BagProduct from '../bag/_BagProduct.vue';
  import OrderDetails from '../bag/_OrderDetails.vue';
  import Bag from '../bag/_Bag.vue';
  import BagTotals from '../bag/_BagTotals.vue';
  import ReviewCard from './_RewardCard.vue';
  import TwModal from '../../components/TwModal.vue';
  import LocationAlerts from '../../components/LocationAlerts.vue';

  import LoginForm from '../users/_LoginForm.vue';
  import ContactInfoForm from './_ContactInfoForm.vue';
  import PaymentMethodForm from './_PaymentMethodForm.vue';

  import TwButton from '../../components/TwButton.vue';
  import TwCateringHelp from '../../components/TwCateringHelp.vue';

  const basketStore = useBasketStore();
  const cateringOrderStore = useCateringOrderStore();
  const menuStore = useMenuStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();

  const router = useRouter();

  const app = getCurrentInstance();

  const state = reactive({
    userPrompt: '',
    recommendations: [] as Product[],
    recommendationsLoaded: false,
    rewardsLoading: true,
    promoCode: '',
    localPreAdjustmentTime: undefined as (DateTime | undefined),
    submittingPromo: false,
    applyingRewards: false,
    availableRewards: undefined as (undefined | RewardInterface[]),
    submittingOrder: false,
    rewards: [] as Reward[],
    loadingCheckout: false,
    productsLoading: [] as string[],
    showRewardsModal: false,
    showRewardsDiscountModal: false,
    showPromoDiscountModal: false,
    selectedReward: undefined as (undefined | RewardInterface),
  })

  onMounted(() => {
    initializeRewards();

    state.recommendationsLoaded = false;

    if (basketStore.basket && cateringOrderStore.cateringOrder) {
      basketStore.fetchUpsells().then((products: Product[]) => {
        if (products.length > 4) {
          state.recommendations = products.slice(0,3);
        } else {
          state.recommendations = products;
        }
        state.recommendationsLoaded = true;
      });
    } else {
      router.push('wizard'); // User doesn't have a location set so force them to pick one;
    }
  })

  const initializeRewards = () => {
    if (userStore.user) {
      userStore.fetchRewards().then((rewards: RewardInterface[]) => {
        if (rewards) {
          state.rewards = rewards;
          state.rewardsLoading = false;
        }
      })
    }
  }

  const currentBasketTimeWanted = computed(() => {
    if (basketStore.basket && basketStore.basket.timewanted) {
      let dt = DateTime.fromFormat(basketStore.basket!.timewanted, 'yyyyMMdd hh:mm')

      return dt;
    } else {
      return null;
    }
  })

  const checkoutText = computed(() => {
    let str = 'CONTINUE TO CHECKOUT'

    // if (basketStore.basket && basketStore.basket!.total) {
    //   str += ' — $'
    //   str += basketStore.basket!.total.toLocaleString("en-US", {minimumFractionDigits: 2});
    // }

    return str;
  })

  const promocodeKeyup = ((event: Event) => {
    if (state.promoCode && state.promoCode.length > 0) {
      if (basketStore.basket?.discountmode == 'coupon') {
        promptForMultipleDiscounts();
      } else {
        submitPromo();
      }
    }
  })
  
  const promoAction = (() => {
    if (state.promoCode && state.promoCode.length > 0) {
      submitPromo();
    }
  })
  
  const submitPromo = (() => {
    if (state.promoCode && state.promoCode.length > 0) {
      state.submittingPromo = true;
      basketStore.applyPromo(state.promoCode).then(() =>{
        state.submittingPromo = false;
        state.showPromoDiscountModal = false;
        state.promoCode = '';
      }).catch((error) => {
        state.showPromoDiscountModal = false;
        if (error.message && error.message == "timeNeedsAdjusted") { 
          state.promoCode = "";
          const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
          // The basket already had a time set on it; so we'll have to notify the user
          setNextAvailableTimeFallback(true, currentTimeWanted, true).then(() => {
            state.submittingPromo = false;
          });
        } else {
          state.submittingPromo = false;
          errorFlash("Promo Code Error", error.message);
        }
      })
    } else {
      errorFlash("Promo Code", "Please enter a valid promo code.")
    }
  })

  const removePromo = ((couponcode: string) => {
    state.submittingPromo = true;
    state.promoCode = '';
    alert('remove promo ' + couponcode);
    basketStore.removePromo(couponcode).then(() =>{
      state.submittingPromo = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted, true).then(() => {
          state.submittingPromo = false;
        });
      } else {
        state.submittingPromo = false;
        errorFlash("Error", error.message);
      }
    })
  })

  const removeDiscount = ((discount: Discount) => {
    state.submittingPromo = true;

    if ((discount as Discount) != null) {
      if ((discount as Discount).discounttype == 'reward') {
        removeRewardDiscount(discount.couponcode);
      } else {
        removePromo(discount.couponcode);
      }
    }
  })

  const promptForMultipleDiscounts = (() => {
    state.showPromoDiscountModal = true;
  })

  const applyRewardClicked = ((reward: RewardInterface) => {
    state.selectedReward = reward;
    let basket = basketStore.basket;

    // if (basket != null && basket.hasCouponsApplied()) {
    //     state.showRewardsDiscountModal = true;
    // } else {
      applyReward(reward);
    // }
  })

  const applyReward = ((reward: RewardInterface) => {
    state.applyingRewards = true;

    basketStore.applyReward(reward.credential_identifier).then(() => {
      state.applyingRewards = false;
      state.showRewardsModal = false;
      state.showRewardsDiscountModal = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted, true).then(() => {
          state.applyingRewards = false;
          state.showRewardsModal = false;
          state.showRewardsDiscountModal = false;
        });
      } else {
        state.applyingRewards = false;
        state.showRewardsModal = false;
        state.showRewardsDiscountModal = false;
        errorFlash("Error", error.message);
      }
    })
  })

  // Using a separate method to remove a reward by its discount instead of from the full reward object
  const removeRewardDiscount = ((rewardcode: string) => {
    state.applyingRewards = true;
    basketStore.removeReward(undefined, rewardcode).then(() => {
      state.applyingRewards = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted, true).then(() => {
          state.applyingRewards = false;
        });
      } else {
        state.applyingRewards = false;
        errorFlash("Error", error.message);
      }
    })
  })

  const removeReward = ((reward: RewardInterface) => {
    state.applyingRewards = true;
    basketStore.removeReward(reward, undefined).then(() => {
      state.applyingRewards = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted, true).then(() => {
          state.applyingRewards = false;
        });
      } else {
        state.applyingRewards = false;
        errorFlash("Error", error.message);
      }
    })
  })

  const rewardsButtonClick = (() => {
     state.showRewardsModal = true;
  })

  const closeRewardsModal = (() => {
     state.showRewardsModal = false;
  })

  const closeRewardsDiscountModal = (() => {
    state.showRewardsDiscountModal = false;
    state.showPromoDiscountModal = false;
  })

  const availableRewardsCount = computed(() => {
    let available = 0;

    if (state.rewards && state.rewards.length > 0) {
      available += state.rewards.length
    }

    return available;
  })

  const applyRewardsWarningPromptTitle = computed(() => {
    let text = "Multiple Discounts";

    // We don't actually support fundraisers in the catering app just yet
    // if (basketStore.appliedFundraiser != null)  {
      // text = "Remove Fundraiser?"
    // }

    return text;
  })
  
  const applyRewardsWarningPromptText = computed(() => {
    let text = "";
    if (state.showPromoDiscountModal) {
      text = "Applying this promo will remove any other discounts you have applied. Are you sure you want to continue?";
    } else {
      text = "Applying this reward will remove any other discounts you have applied. Are you sure you want to continue?";
    }

    // We don't actually support fundraisers in the catering app just yet
    // if (basketStore.appliedFundraiser != null)  {
      // text = "Applying rewards to this order will remove the '\(basketStore.appliedFundraiser)' fundraiser. Do you wish to continue?."
    // }

    return text;
  })

  const removeProduct = ((bpid: number) => {
    const identifier = bpid+'-'+(Math.round(Date.now() / 1000)).toString()
    state.productsLoading.push(identifier)

    basketStore.removeProduct(bpid).then(() => {
      state.productsLoading = state.productsLoading.filter((id) => {
        return identifier != id
      })
    })
  })

  function isLoadingProduct(id: string): boolean {
    let bool = false;
    if (state.productsLoading.length > 0) {
      let ids = state.productsLoading.map((pl: string) => {
        return pl.split('-')[0];
      })

      bool = ids.indexOf(id.toString()) >= 0;
    }

    return bool;
  }

  // TODO: Make this accept a qty too
  const addProduct = (id: string) => {
    const identifier = id+'-'+(Math.round(Date.now() / 1000)).toString()
    state.productsLoading.push(identifier)

    basketStore.addProduct(id, 1, "", [], [], undefined).then(() => {
      state.productsLoading = state.productsLoading.filter((id) => {
        return identifier != id
      })
    })
  }

  const updateProduct = ((product: BasketProduct, bpid: string, qty: number) => {
    const identifier = bpid+'-'+(Math.round(Date.now() / 1000)).toString()
    state.productsLoading.push(identifier)

    let choices: number[] = [];
    if (product.choices) {
      product.choices.forEach((choice) => {
        choices.push(choice.optionid)
      })
    }

    basketStore.updateProduct(product.productId.toString(), bpid, qty, product.specialinstructions, choices, []).then(() => {
      state.productsLoading = state.productsLoading.filter((id) => {
        return identifier != id
      })
    })
  })

  const pickTimeAdjustment = (() => {
    state.localPreAdjustmentTime = undefined;
    router.push({ name: 'wizard-step', params: { step: 4}})
  })

  const closeTimeAdjustment = (() => {
    state.localPreAdjustmentTime = undefined;
  })

  const rewardsButtonText = computed(() => {
    let buttonText = ""
    if (basketStore.basket) {
      const manualRewards = basketStore.basket!.manuallyAppliedRewards();
      let rewardsCount = 0

      if (availableRewardsCount.value > 0 && state.rewards) {
        rewardsCount = availableRewardsCount.value
      }

      if (availableRewardsCount.value > 0 && state.rewards) {
        buttonText = 'View '+ state.rewards.length + ' ' + app!.appContext.config.globalProperties.pluralizeProductName('Reward', state.rewards.length);
      } else if (state.rewardsLoading){
        buttonText = "Loading Rewards"
      } else {
        buttonText = "No available rewards"
      }
    }

    return buttonText
  })

  const presetTimeWanted = ((): Promise<any>  => {
    const basket = basketStore.basket;
    const location = userStore.userLocation;
    const cErt = basket!.calculatedEarliestReadyTime(location!);

    return new Promise((resolve, reject) => {
      if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder!.time_wanted) {

        let dt = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted);
        
        if (cErt < dt) { // The catering order wants to set the timewanted and its not before the basket's adjusted earliest ready
          basketStore.setTimeWanted(dt, false).then(() => {
            resolve('');
          }).catch((error: Error) => {
            // The time couldn't be set so we'll try the next available and let the user know
            const currentTimeWanted = DateTime.fromFormat(basket!.timewanted, 'yyyyMMdd HH:mm');
            setNextAvailableTimeFallback(false, currentTimeWanted, false).then(() => {resolve('')});    
          });
        } else {
          basketStore.setTimeWanted(cErt, false).then(() => {
            // Notify user that time has been adjusted
            cateringOrderStore.preAdjustmentTime = dt;
            resolve('');
          }).catch((error: Error) => {
            // The time couldn't be set so we'll try the next available and let the user know
            setNextAvailableTimeFallback(false, cErt, false).then(() => {resolve('')});
          });
        }
      } else {
        basketStore.setTimeWanted(cErt, false).then(() => {
          // Just continue
          resolve('');
        }).catch((error: Error) => {
          // The user hasn't specified any time so we are setting the time for them; if it fails and we fall 
          // back to next avilalbe there is no need to notify
          setNextAvailableTimeFallback(false, cErt, false).then(() => {resolve('')});
        });
      }
    })
  })

  const setNextAvailableTimeFallback = ((notifyUser: boolean, timewanted: DateTime, localAdjustment: boolean): Promise<any> => {
    return new Promise((resolve, reject) => {
      // Cache the existing cateringOrder time wanted
      let previouslySetTime = undefined as (undefined | DateTime);
      if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder!.time_wanted) {
        previouslySetTime = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted);
      }

      basketStore.setNextAvailableTime(timewanted, true).then(() => {
        if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder!.time_wanted) {
          let dt = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted);

          // Make sure the new time is not actually the time the user had set previously
          if (previouslySetTime && basketStore.basket && basketStore.basket!.timewanted != previouslySetTime.toFormat('yyyyMMdd HH:mm')) {
            if (localAdjustment) {
              state.localPreAdjustmentTime = dt;
            } else {
              cateringOrderStore.preAdjustmentTime = dt;
            }
          }
        }
        resolve('');
      }).catch((error: any) => {
        if (error.message && error.message == "timeNeedsAdjusted" && basketStore.basket) { 
          const currentTimeWanted = DateTime.fromFormat(basketStore.basket!.timewanted, 'yyyyMMdd hh:mm');
          // The basket already had a time set on it; so we'll have to notify the user
          setNextAvailableTimeFallback(true, currentTimeWanted, localAdjustment).then(() => {
            if (!localAdjustment) {
              state.loadingCheckout = false;
              router.push('checkout');
            }
          });
        } else {
          errorFlash('Error', error.message);
          if (!localAdjustment) {
            state.loadingCheckout = false;
            router.push('checkout');
          }
        }
      })
    }); 
  });

  const errorFlash = (title: string, text: string) => {
    const message = {
      id: Math.round(Date.now() / 1000),
      messageType: "danger",
      text: text,
      headline: title,
      delay: 0, // ms
      icon: "",
      cssClass: "",
    } as FlashMessage;
    flashMessageStore.addMessage(message);
  }

  const navigateToCheckout = () => {
    state.loadingCheckout = true;
    const basket = basketStore.basket;

    if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder.time_wanted == null) {
      // The user has not yet set a time wanted so go force one
      errorFlash("Select a Time", "You must select a time for your order to be ready.")
      router.push('/wizard/4');
    // Preset timewanted
    } else if (basket?.timemode == "asap" || basket?.timewanted == null || typeof(basket?.timewanted) == undefined ) {
      presetTimeWanted().then(() => {
        basketStore.validateBasket(false).then(() => {
          state.loadingCheckout = false;
          router.push('checkout');
        }).catch((error: any) => {
          if (error.message && error.message == "timeNeedsAdjusted") {
            const currentTimeWanted = DateTime.fromFormat(basket!.timewanted, 'yyyyMMdd hh:mm');
            // The basket already had a time set on it; so we'll have to notify the user
            setNextAvailableTimeFallback(true, currentTimeWanted, false).then(() => {
              state.loadingCheckout = false;
              router.push('checkout');
            });
          } else {
            state.loadingCheckout = false;
            router.push('checkout');
          }
        })
      })
    } else {
      // Validate the basket and force it to adjust time if needed
      basketStore.validateBasket(false).then(() => {
        state.loadingCheckout = false;
        router.push('checkout');
      }).catch((error: any) => {
        if (error.message && error.message == "timeNeedsAdjusted") { 
          const currentTimeWanted = DateTime.fromFormat(basket.timewanted, 'yyyyMMdd hh:mm');
          // The basket already had a time set on it; so we'll have to notify the user
          setNextAvailableTimeFallback(true, currentTimeWanted, false).then(() => {
            state.loadingCheckout = false;
            router.push('checkout');
          });
        } else {
          state.loadingCheckout = false;
          router.push('checkout');
        }
      })
    }
  }

  const cancelEditOrder = () => {
    basketStore.cancelEditOrder().then(() => {
      router.push('wizard');
    })
  }

  const showEditingOrderAlert = computed(() => {
    return basketStore.editing
  })

  const editCutoffTime = computed(() => {
    return basketStore.editOrderCutoffTime
  })

</script>